import styled from 'styled-components';
import { colors } from 'global/colors';

export const FlexContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const SearchContainer = styled.div`
  display: flex;
  background: ${colors.white};
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.1);
  padding: 5px;
  border-radius: 5px;
  user-select: none;
  width: 100%;
  :focus-within {
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);
  }
`;

export const SearchInput = styled.input`
  font-size: 12px;
  border: none;
  background: transparent;
  outline: none;
  color: ${colors.darkGray};
  flex: 1;
`;

export const ActionButtons = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 5px;
`;
